import { Stack } from 'src/design/atoms/Stack';
import { Title } from 'src/design/atoms/Title';
import React from 'react';
import {
  useBackgroundJobOverview,
  useBackgroundJobServers,
} from 'src/api/queries/admin/useBackgroundJobs';
import { Header } from 'src/design/organisms/Header';
import { BackgroundJobHistoryChart } from 'src/routes/Settings/BackgroundJobs/components/BackgroundJobHistoryChart';
import { BackgroundJobServersAndQueuesTable } from 'src/routes/Settings/BackgroundJobs/components/BackgroundJobServersAndQueuesTable';
import { BackgroundJobsTable } from 'src/routes/Settings/BackgroundJobs/components/BackgroundJobsTable';
import { RecurringBackgroundJobsTable } from 'src/routes/Settings/BackgroundJobs/components/RecurringBackgroundJobsTable';

export const BackgroundJobs: React.FC = () => {
  const overviewQuery = useBackgroundJobOverview();
  const serversQuery = useBackgroundJobServers();

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [{ text: 'Settings' }, { text: 'Background Jobs' }],
        }}
        title="Background Jobs"
        helpText="Monitor and manage queued, scheduled, failed and recurring background jobs."
      />

      <Stack gap="lg">
        <BackgroundJobHistoryChart
          hourlyHistory={overviewQuery.data?.hourlyHistory ?? []}
        />

        <Stack gap="xs">
          <Title order={5}>Jobs</Title>
          <BackgroundJobsTable />
        </Stack>

        <Stack gap="xs">
          <Title order={5}>Recurring Jobs</Title>
          <RecurringBackgroundJobsTable />
        </Stack>

        <BackgroundJobServersAndQueuesTable
          servers={serversQuery.data ?? []}
          queues={overviewQuery.data?.queues ?? []}
        />
      </Stack>
    </>
  );
};
